import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import SyncIcon from '@material-ui/icons/Sync';
import IconButton from '@material-ui/core/IconButton';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/UI/Typography';
import RichTextEditor from 'Components/UI/RichTextEditor';
import Button from 'Components/UI/Button';
import Info from './Info';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    flexFlow: 'column',
    marginRight: theme.spacing(2),
  },
  header: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
  },
  headerText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  headerRightSide: {
    display: 'flex',
    flexFlow: 'row',
  },
  refreshButton: {
    marginRight: theme.spacing(1),
  },
  subHeader: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  suspendedStatus: {
    marginTop: theme.spacing(2),
    color: theme.palette.facet.orange,
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(2),
  },
  labelsAndValues: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  labelsAndValuesLabel: {
    marginTop: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    width: 70,
  },
  labelsAndValuesValue: {
    marginTop: theme.spacing(2),
    fontWeight: theme.typography.fontWeightMedium,
  },
  labelsAndValuesL: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1,
  },
  labelsAndValuesR: {
    display: 'flex',
    flexFlow: 'column',
    marginLeft: theme.spacing(2),
  },
  saveButton: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
  },
});

const View = ({
  classes, source, sourceId, reasons, notes, setNotes, onSaveInvestigation, onClose, onClickRefresh, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} {...amplitudeRootNodeProps}>
      <div className={classes.header}>
        <Typography
          variant="h4"
          className={classes.headerText}
          color="primary"
        >
          Investigation
        </Typography>
        <div className={classes.headerRightSide}>
          <IconButton
            className={classes.refreshButton}
            onClick={onClickRefresh}
            variant="contained"
            color="primary"
          >
            <SyncIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={onClose}
          >
            <CancelIcon />
          </IconButton>
        </div>
      </div>
      <Typography
        variant="h6"
        className={classes.subHeader}
      >
        {sourceId}
      </Typography>
      <Info />
      <Box className={classes.row}>
        <Typography className={classes.labelsAndValuesLabel}>
          Source
        </Typography>
        <Typography debugColor="deepPink" className={classes.labelsAndValuesValue}>
          {source}
        </Typography>
      </Box>
      <Box className={classes.row}>
        <Typography debugColor="deepPink" className={classes.labelsAndValuesLabel}>
          Reasons
        </Typography>
        <Box>
          {
            reasons.map(reason => <Typography debugColor="deepPink" className={classes.labelsAndValuesValue}>{reason}</Typography>)
          }
        </Box>
      </Box>
      <Box className={classes.row}>
        <Typography debugColor="deepPink" className={classes.labelsAndValuesLabel}>
          Notes
        </Typography>
        <Box className={classes.labelsAndValuesL}>
          <RichTextEditor
            value={notes}
            onChange={setNotes}
            size="sm"
          />
          <Button
            onClick={() => {
              onSaveInvestigation();
            }}
            type="submit"
            test="send-message"
            aria-label="send message"
            color="secondary"
            variant="contained"
            className={classes.saveButton}
          >
            Save Note
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  source: PropTypes.string.isRequired,
  sourceId: PropTypes.string.isRequired,
  reasons: PropTypes.array.isRequired,
  notes: PropTypes.string.isRequired,
  setNotes: PropTypes.func.isRequired,
  onSaveInvestigation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickRefresh: PropTypes.func.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
